import { Schema, arrayOf } from 'normalizr'

export const comment = new Schema('comments')
export const arrayOfComments = arrayOf(comment)
